import React, { useEffect, useState } from "react";
import { getOrdersStatistics } from "../../utils/dataFetch";

export default function OrdersStatistics({ endDate }) {
    const [error, setError] = useState("");
    const [overallAmount, setOverallAmount] = useState(0);
    const [overallIncome, setOverallIncome] = useState(0);
    const [averageCheck, setAverageCheck] = useState(0);
    const [checkCount, setCheckCount] = useState(0);
    const [activeCheckCount, setActiveCheckCount] = useState(0);
    const [activeAmount, setActiveAmount] = useState(0);

    useEffect(() => {
        const fetchOrdersReport = async () => {
            try {
                const tempStart = new Date(endDate);
                tempStart.setHours(0, 0, 0, 0);
                const tempEnd = new Date(endDate);
                tempEnd.setHours(23, 59, 59, 999);
                const result = await getOrdersStatistics(tempStart, tempEnd);
                setOverallAmount(result.overallAmount);
                setOverallIncome(result.overallIncome);
                setAverageCheck(result.averageCheck);
                setCheckCount(result.checkCount);
                setActiveCheckCount(result.activeCheckCount);
                setActiveAmount(result.activeAmount);
            } catch (error) {
                setError("Помилка завантаження даних!");
            }
        };
        fetchOrdersReport();
    }, [endDate]);

    return (
        <div className="col-12 dashboard--item">
            <div className="dashboard--item--container p-3">
                {error && (
                    <div className="alert alert-danger m-auto rounded-5">
                        {error}
                    </div>
                )}
                {!error && (
                    <>
                        <div className="row d-flex flex-column mt-1">
                            <h5 className="text-center fw-bold mb-2">
                                Виконані замовлення
                            </h5>
                            <div className="col col-auto m-0 ms-1 me-1 p-0 text-center d-flex justify-content-around">
                                <div className="m-0 p-0 text-center">
                                    <div>Виручка</div>
                                    <div className="fw-light">
                                        {overallAmount}
                                    </div>
                                </div>
                                <div
                                    className="border-end border-1 border-black"
                                    style={{ width: "1px" }}
                                ></div>
                                <div className="m-0 p-0 text-center">
                                    <div>Дохід</div>
                                    <div className="fw-light">
                                        {overallIncome}
                                    </div>
                                </div>
                                <div
                                    className="border-end border-1 border-black"
                                    style={{ width: "1px" }}
                                ></div>
                                <div className=" m-0 p-0 text-center">
                                    <div>Сер. чек</div>
                                    <div className="fw-light">
                                        {averageCheck}
                                    </div>
                                </div>
                                <div
                                    className="border-end border-1 border-black"
                                    style={{ width: "1px" }}
                                ></div>
                                <div className="m-0 p-0 text-center">
                                    <div>Кількість</div>
                                    <div className="fw-light">{checkCount}</div>
                                </div>
                            </div>
                            {activeCheckCount > 0 && (
                                <>
                                    <h5 className="text-center fw-bold mb-2 mt-2">
                                        Замовлення в процесі
                                    </h5>
                                    <div className="col col-auto m-0 ms-1 me-1 p-0 text-center d-flex justify-content-around">
                                        <div className="m-0 p-0 text-center">
                                            <div>Виручка</div>
                                            <div className="fw-light">
                                                {activeAmount}
                                            </div>
                                        </div>
                                        <div
                                            className="border-end border-1 border-black"
                                            style={{ width: "1px" }}
                                        ></div>
                                        <div className="m-0 mt-1 p-0 text-center">
                                            <div>Кількість</div>
                                            <div className="fw-light">
                                                {activeCheckCount}
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
